'use client'

import cx from 'classnames'
import { FieldErrors } from 'react-hook-form/dist/types/errors'

const ErrorMessage = ({ name, errors }: { name: string; errors: FieldErrors }) => {
  const periodSeparateValue = name.split('.')
  // @ts-ignore
  const errorMessages: string[] | null = periodSeparateValue.reduce((result, key) => {
    if (result == null) return null
    const nextResult = result[key]
    return nextResult == undefined ? null : nextResult
  }, errors)

  return <>{errorMessages != null ? <div className={cx('c-error-message')}>{errorMessages[0]}</div> : <></>}</>
}

export default ErrorMessage
